/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import sections from '../sections';
import styles from '../../../../styles/guest/partials/backgrounds.module.scss';

const propTypes = {
    currentIndex: PropTypes.number,
    className: PropTypes.string,
};

const defaultProps = {
    currentIndex: null,
    className: null,
};

const Backgrounds = ({ currentIndex, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        {sections.map(({ slug, Background }, sectionIndex) => (
            <div
                key={`background-${slug}`}
                className={classNames([
                    styles.background,
                    { [styles.active]: sectionIndex === currentIndex },
                ])}
            >
                <Background active={sectionIndex === currentIndex} />
            </div>
        ))}
    </div>
);

Backgrounds.propTypes = propTypes;
Backgrounds.defaultProps = defaultProps;

export default Backgrounds;
